/// <reference path="../../Scripts/typings/jquery/jquery.d.ts" />
/// <reference path="../../Scripts/typings/toastr/toastr.d.ts" />
/// <reference path="../../Scripts/typings/knockout/knockout.d.ts" />
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('common/viewmodelbase',["require", "exports", "durandal/app", "models/portal", "models/account", "models/socialnetwork", "services/applicationstorage", "services/taskmanager", "plugins/router"], function (require, exports, App, Portal, Account, Socialnetwork, Applications, Tasks, router) {
    "use strict";
    var ViewModelBase = (function () {
        function ViewModelBase() {
            this.taskManager = new Tasks.Manager();
            this.applications = new Applications();
            //for (var method in this) {
            //	if (typeof this[method] == "function") {
            //		this[method] = this[method].bind(this);
            //	}
            //}
        }
        // #region override
        ViewModelBase.prototype.activate = function (routeData) {
            var settings = null;
            var path = null;
            var queryString = null;
            var parameters = null;
            // Aufrufparameter auswerten
            if (routeData instanceof Portal.ParameterList) {
                parameters = routeData;
            }
            else {
                parameters = new Portal.ParameterList();
                parameters.add("unknown", routeData);
            }
            // application settings aus DB laden
            var instruction = router.activeInstruction();
            if (instruction != null) {
                path = instruction.fragment.substring(instruction.fragment.indexOf("/") + 1); //instruction.params[0];
                queryString = router.parseQueryString(instruction.queryString);
                var node = null;
                // child-routes
                if (path.indexOf("/") > 0) {
                    var modulePath = path.substring(path.indexOf("/") + 1);
                    var query = { fragment: modulePath };
                    node = Portal.Context.shell.findNodeFor(query);
                }
                else {
                    node = Portal.Context.shell.findNodeFor(instruction);
                }
                if (node != null && node.application != null) {
                    settings = node.application.settingsXml;
                }
                else if (path !== "") {
                    settings = this.applications.getSettings(path);
                }
            }
            // context zusammensetzen und übergeben
            this._context = new Portal.ApplicationContext(path, settings, queryString, parameters);
            return this.onActivated(this._context);
        };
        ViewModelBase.prototype.canDeactivate = function () {
            var path = null;
            var instruction = router.activeInstruction();
            if (instruction != null) {
                path = instruction.fragment.substring(instruction.fragment.indexOf("/") + 1); //instruction.params[0];
            }
            return this.onBeforeClosing(path);
        };
        ViewModelBase.prototype.deactivate = function (close) {
            this.onClosed();
        };
        // #endregion
        // #region base functionality to override from childs
        ViewModelBase.prototype.onActivated = function (context) {
        };
        ViewModelBase.prototype.onBeforeClosing = function (path) {
            return true;
        };
        ViewModelBase.prototype.onClosed = function () {
        };
        Object.defineProperty(ViewModelBase.prototype, "activeOrganization", {
            // #endregion
            get: function () {
                var organization;
                App.trigger("currentSelectedClient", function (client) { return organization = client; });
                if (organization == null) {
                    var organization = new Socialnetwork.Organization();
                    organization.organizationId = Account.Session.principal.organizationId;
                    organization.name = Account.Session.principal.organizationName;
                }
                return organization;
            },
            enumerable: true,
            configurable: true
        });
        ViewModelBase.prototype.getContentHeight = function () {
            var hoehe = 800;
            if (window.innerHeight) {
                hoehe = self.innerHeight;
            }
            else if (document.documentElement && document.documentElement.clientHeight) {
                hoehe = document.documentElement.clientHeight;
            }
            else if (document.body) {
                hoehe = document.body.clientHeight;
            }
            return hoehe - 135;
        };
        ViewModelBase.prototype.getSettingsPropertyValueFor = function (propertyName) {
            var settingsxml = jQuery.parseXML(this._context.settings);
            if (settingsxml != null) {
                var properties = settingsxml.getElementsByTagName("property");
                for (var i in properties) {
                    var property = properties[i];
                    if (property.attributes.getNamedItem("name").nodeValue === propertyName) {
                        return property.attributes.getNamedItem("value").nodeValue;
                    }
                }
            }
            return null;
        };
        ViewModelBase.prototype.getTranslation = function (key) {
            return $.t(key);
        };
        return ViewModelBase;
    }());
    exports.ViewModelBase = ViewModelBase;
    var ListViewModelBase = (function (_super) {
        __extends(ListViewModelBase, _super);
        function ListViewModelBase() {
            _super.call(this);
            this.selectedItems = ko.observableArray();
        }
        return ListViewModelBase;
    }(ViewModelBase));
    exports.ListViewModelBase = ListViewModelBase;
});

